module.exports = __webpack_public_path__ + "img/logo-bnr.971d4397.png";